<template>
  <div>

    <!-- Initial page loading -->
    <b-container
      v-if="isLoading"
      class="text-center d-flex justify-content-center"
    >
      <b-form>
        <br><br><br>

        <h5>{{ translate("loading") }}</h5>

        <br>

        <b-spinner
          style="color: rgb(109,122,82) !important"
          variant="warning"
        />
      </b-form>
    </b-container>


    <!-- Page loaded -->
    <div v-else>

      <b-container
        fluid
        v-if="inSession"
      >

        <!-- Search -->
        <b-form
          class="w-search"
          style="width:70%; margin:0 auto;"
          @submit.prevent
        >

          <br>

          <b-form-group>
            <b-form-input
              id="input-search"
              class="w-input"
              style="background-color:white !important; padding-left:40px"
              v-model="search_text"
              aria-describedby="input-live-help input-live-feedback"
            />
          </b-form-group>


          <!-- Search icon -->
          <div
            style="
              width:20px;
              position:relative;
              float:left;
              top:-39px;
              left:10px;
              margin:0;
              padding:0;
            "
          >
            <font-awesome-icon
              style="
                font-size:17px;
                color:rgb(109,122,82);
              "
              icon="search"
            />
          </div>


          <!-- Search status / Counts -->
          <div class="w-results-toolbar">

            <!-- Searching -->
            <div
              v-if="isSearching"
              class="w-results-count d-flex align-items-center justify-content-center"
              style="width:100%;"
            >
              <b-spinner
                small
                style="color:rgb(109,122,82); margin-right:8px;"
              />

              {{ translate("searching") }}...
            </div>


            <!-- Search error -->
            <div
              v-else-if="searchError"
              class="w-results-count"
              style="color:#b00020;"
            >
              {{ translate("search failed. please try again.") }}
            </div>


            <!-- Result count -->
            <div
              v-else-if="normalizeSearchText(search_text).length >= 3"
              class="w-results-count"
            >
              {{ translate("showing") }}
              {{ wine_count }}
              {{ translate("bottles") }}
            </div>

          </div>

        </b-form>


        <!-- Results -->
        <div>

          <b-row
            class="justify-content-center"
            style="margin:0"
          >

            <b-col
              v-for="(entry, index) in entries"
              :key="entry._id"
              :item="entry"
              :index="index"
              class="
                w-tile
                m-2
                d-inline-flex
                justify-content-center
                w-cursor-click
              "
              xs="12"
              sm="6"
              md="4"
              lg="2"
              xl="2"
              style="
                display:block;
                min-width:300px;
                margin:20px !important;
              "
            >

              <b-row
                style="width:100%"
                @click="onSelect(entry._id)"
              >

                <!-- Bottle image -->
                <b-col
                  cols="3"
                  class="justify-content-center"
                  style="
                    height:100%;
                    width:auto;
                    padding:0;
                  "
                >

                  <b-img
                    v-if="
                      entry.image_files &&
                      entry.image_files[0]
                    "
                    center
                    style="
                      height:100%;
                      width:auto;
                      position:absolute;
                      right:0px;
                    "
                    :src="entry.image_files[0].dataURL"
                  />

                  <b-img
                    v-else
                    center
                    style="
                      height:100%;
                      width:auto;
                      position:absolute;
                      right:0px;
                    "
                    :src="require('@/assets/img/bottle.png')"
                  />

                </b-col>


                <!-- Wine information -->
                <b-col
                  cols="9"
                  class="d-table-cell"
                >

                  <div>

                    <p class="t-title2">
                      {{ entry.name }}
                    </p>

                    <p
                      class="t-subtitle"
                      v-if="entry.type"
                    >
                      {{ entry.type }}
                    </p>

                    <p
                      class="t-subtitle"
                      style="color:white"
                      v-else
                    >
                      bogus text here
                    </p>

                    <hr style="margin:5px 0 5px 0">

                    <p
                      class="t-text"
                      v-if="entry.appellation"
                    >
                      {{ entry.appellation }}
                    </p>

                    <p
                      class="t-smalltext"
                      v-if="entry.classification"
                    >
                      {{ entry.classification }}
                    </p>

                    <p
                      class="t-smalltext"
                      v-if="entry.color"
                    >
                      {{ entry.color }}
                    </p>

                  </div>


                  <!-- Certified -->
                  <div
                    v-if="entry.certified == true"
                    style="
                      position:absolute;
                      top:168px;
                      right:0px;
                      height:28px;
                      width:28px;
                    "
                  >
                    <font-awesome-icon
                      :id="'q' + index"
                      style="
                        font-size:24px;
                        font-weight:bold;
                        color:rgb(109,122,82);
                      "
                      icon="check"
                    />

                    <b-tooltip
                      :target="'q' + index"
                      custom-class="w-tooltip-good"
                    >
                      certified by the WyneMaker
                    </b-tooltip>
                  </div>


                  <!-- Not certified -->
                  <div
                    v-else
                    style="
                      position:absolute;
                      top:168px;
                      right:0px;
                      height:28px;
                      width:28px;
                    "
                  >
                    <font-awesome-icon
                      :id="'q' + index"
                      style="
                        font-size:24px;
                        font-weight:bold;
                        color:rgb(195,147,130);
                      "
                      icon="question"
                    />

                    <b-tooltip
                      :target="'q' + index"
                      custom-class="w-tooltip-bad"
                    >
                      not certified
                    </b-tooltip>
                  </div>

                </b-col>

              </b-row>

            </b-col>

          </b-row>


          <br>


          <!-- Pagination
               Hide it while a new search is running or failed,
               because the displayed pagination belongs to the
               previous completed result set. -->
          <Paginator
            v-if="
              wine_count > 0 &&
              !isSearching &&
              !searchError
            "
            v-model="current_page"
            :total-rows="wine_count"
            :per-page.sync="per_page"
            @input="onPageChanged"
          />

        </div>

      </b-container>

    </div>

  </div>
</template>

<script>
import { translate_word } from "../assets/js/translate.js"
import Wines_Search from "../Wines_Search.js"

import Paginator from "@/components/Paginator.vue";

export default {
  name: "LibrarySearch",

  components: {
    Paginator,
  },

  data() {
    return {
      debug: false,

      isLoading: true,
      isSearching: false,
      searchError: null,

      searchRequestId: 0,

      entries: [],

      search_text: "",
      search_timer: null,
      wine_count: 0,
      current_page: 1,
      per_page: 6
    }
  },

  computed: {
    inSession() {
      return this.$store.state.inSession
    },

    currentLanguage() {
      return this.$store.state.language
    },

    searchState() {
      return this.$store.state.search_state
    }
  },
  watch: {
    search_text(newValue) {
      clearTimeout(this.search_timer)

      const text = this.normalizeSearchText(newValue || "")

      // Every change invalidates any older request
      this.searchRequestId++

      if (text.length < 3) {
        this.entries = []
        this.wine_count = 0
        this.current_page = 1
        this.isSearching = false
        return
      }

      // We are now waiting to launch a new search.
      // Do not show "0 results" during this period.
      this.isSearching = true

      this.search_timer = setTimeout(() => {
        this.current_page = 1
        this.onSearch()
      }, 400)
    }
  },
  async mounted() {
    await this.onSearch()
    this.isLoading = false
  },

  methods: {
    async onNewSearch() {
      this.current_page = 1
      await this.onSearch()
    },

    async onPageChanged(page) {
      this.current_page = page
      await this.onSearch()
    },

    async onSearch() {
      const local_debug = false

      if (local_debug || this.debug) {
        console.log("")
        console.log("LibrarySearch.onSearch: START")
      }

      const normalizedSearch = this.normalizeSearchText(
        this.search_text || ""
      )

      // No search below 3 characters
      if (normalizedSearch.length < 3) {
        this.entries = []
        this.wine_count = 0
        this.isSearching = false
        this.searchError = null

        return
      }


      // Every server request gets its own ID.
      // Only the newest request is allowed to update the UI.
      const requestId = ++this.searchRequestId


      // Search has started
      this.isSearching = true
      this.searchError = null


      const postdata = {
        search_text: normalizedSearch,
        skip: (this.current_page - 1) * this.per_page,
        limit: this.per_page
      }


      if (local_debug || this.debug) {
        console.log(
          "LibrarySearch.onSearch: requestId =",
          requestId
        )

        console.log(
          "LibrarySearch.onSearch: postdata =",
          postdata
        )
      }


      try {

        const result = await Wines_Search.search(postdata)


        // ---------------------------------------------
        // IMPORTANT:
        // A newer search was started while this request
        // was still travelling over the network.
        //
        // Ignore this obsolete response completely.
        // ---------------------------------------------
        if (requestId !== this.searchRequestId) {

          if (local_debug || this.debug) {
            console.log(
              "LibrarySearch.onSearch: ignoring stale response",
              requestId
            )
          }

          return
        }


        // Latest request: update the UI
        this.wine_count = Number(result.count) || 0

        this.entries = Array.isArray(result.list)
          ? result.list
          : []

        this.searchError = null


        if (local_debug || this.debug) {

          console.log(
            "LibrarySearch.onSearch: wine_count =",
            this.wine_count
          )

          console.log(
            "LibrarySearch.onSearch: entries =",
            this.entries
          )
        }


      } catch (error) {

        // If this error belongs to an old request,
        // ignore it as well.
        if (requestId !== this.searchRequestId) {

          if (local_debug || this.debug) {
            console.log(
              "LibrarySearch.onSearch: ignoring stale error",
              requestId
            )
          }

          return
        }


        console.error(
          "LibrarySearch.onSearch: error =",
          error
        )


        // Real error on the latest search
        this.entries = []
        this.wine_count = 0

        this.searchError = true


      } finally {

        // An old request must NEVER switch off the
        // spinner belonging to a newer request.
        if (requestId === this.searchRequestId) {
          this.isSearching = false
        }

      }


      if (local_debug || this.debug) {
        console.log("LibrarySearch.onSearch: STOP")
      }
    },

    onSelect(id) {
      const entry = this.entries.find(entry => entry._id === id)

      if (!entry) return

      this.$store.commit("setPage", "WineShow")

      if (entry.winery_id) {
        this.$router.push({
          path: "/WineShow",
          query: {
            cellar_id: this.$route.query.cellar_id,
            niche_id: this.$route.query.niche_id,
            wine_id: id
          }
        })
      } else {
        this.$router.push({
          path: "/WineShow",
          query: {
            cellar_id: this.$route.query.cellar_id,
            niche_id: this.$route.query.niche_id,
            c_wine_id: id
          }
        })
      }
    },

    normalizeSearchText(value) {
      let text = String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ß/g, "ss")
        .replace(/æ/g, "ae")
        .replace(/œ/g, "oe")
        .replace(/\u00a0/g, " ")              // non-breaking spaces
        .replace(/[’‘`´]/g, "'")              // apostrophes
        .replace(/[-–—_/.,;:()[\]{}]/g, " ")  // punctuation
        .replace(/\s+/g, " ")
        .trim()

      const synonyms = {
        // colors
        blanc: "white",
        wit: "white",
        weiss: "white",
        bianco: "white",
        branco: "white",

        rouge: "red",
        rood: "red",
        rot: "red",
        rosso: "red",
        rojo: "red",
        tinto: "red",

        rose: "rose",
        rosado: "rose",
        rosato: "rose",

        // countries
        france: "france",
        frankrijk: "france",
        frankreich: "france",
        francia: "france",
        franca: "france",

        spain: "espana",
        espagne: "espana",
        espana: "espana",
        spanje: "espana",
        spanien: "espana",
        spagna: "espana",
        espanha: "espana",

        italy: "italia",
        italie: "italia",
        italien: "italia",
        italia: "italia",

        germany: "deutschland",
        allemagne: "deutschland",
        duitsland: "deutschland",
        alemania: "deutschland",
        germania: "deutschland",
        deutschland: "deutschland",

        austria: "osterreich",
        osterreich: "osterreich",
        autriche: "osterreich",
        oostenrijk: "osterreich",

        portugal: "portugal",

        greece: "ellada",
        grece: "ellada",
        griekenland: "ellada",
        griechenland: "ellada",
        grecia: "ellada",
        ellada: "ellada"
      }

      return text
        .split(" ")
        .filter(Boolean)
        .map(word => synonyms[word] || word)
        .join(" ")
    },

    translate(string) {
      return translate_word(string, this.currentLanguage)
    }
  }
}
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
</style>